<template>
    <div class="main">
        <div class="app_name">
            <img src="https://openpic.timelywise.cn/web/20250701/logo.png" alt="乃师" loading="lazy">
            <span>乃师</span>
        </div>

        <div class="app_width_box">
            <div class="app_desc">
                <div>用科学和智能</div>
                <div>重新定义语言学习体验</div>
            </div>
        </div>

        <div class="download_box" @click="downApp" v-if="platformOsName != '' && platformOsName != 'Linux' && platformOsName != 'unknown'">
            <img class="platform_icon" :src="platformOsNameIcon" alt="" loading="lazy">
            <span>下载 {{ platformOsName }}版</span>
        </div>

        <div class="download_list">
            <a class="download-link" :href="iosAppUrl" >Download for IOS</a>
            <a class="download-link" :href="macosAppUrl" >Download for macOS</a>
            <a class="download-link" :href="windwosAppUrl" >Download for Windows</a>
            <a class="download-link" :href="androidAppUrl" >Download for Android</a>
        </div>

        <div class="big_image_bg">
            <img class="big_image" src="https://openpic.timelywise.cn/web/20250701/home.png" alt="" loading="lazy">
        </div>

        <div class="app_width_box">
            <div class="text_public text_1">沉浸有趣 23种题型交互</div>
        </div>

        <div class="carousel_container_box">
            <img class="carousel_arrow_icon" src="@/assets/swiper_l.png" @click="prevSlide" loading="lazy">
            <div class="big_image_bg">
                <div class="carousel_container">
                    <swiper 
                        class="carousel_container_swiper" 
                        :autoplay="{
                            delay: 5000,
                            disableOnInteraction: false
                        }"
                        :pagination="{
                            el: '.swiper-pagination',
                            clickable: true
                        }"
                        :loop="true"
                        @swiper="onSwiper"
                        @slideChange="onSlideChange"
                    >
                        <swiper-slide v-for="(slide, i) in slides" :key="i">
                            <div class="carousel_item">
                                 <img :src="slide.image" :alt="slide.title" loading="lazy">
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
            <img class="carousel_arrow_icon" src="@/assets/swiper_r.png" @click="nextSlide">
        </div>
        <div class="carousel_container_box">
            <div class="carousel_container_in" ref="scrollContainer">
                <div v-for="(slide, i) in slides" :key="i" @click="goToSlide(i)"
                :class="[ currentSlideIndex == i ? 'carousel_container_in_img' : 'carousel_container_in_img_un' ]" 
                :ref="'slide_' + i">
                    <img :src="slide.image" :alt="slide.title" loading="lazy">
                </div>
            </div>
        </div>

        <div class="app_width_box">
            <div class="text_public text_2">黄金学练 提高学习效率</div>
        </div>

        <div class="big_image_bg">
            <img class="big_image1" src="https://openpic.timelywise.cn/web/20250701/3-leared.png" alt="" loading="lazy">
        </div>

        <div class="app_width_box">
            <div class="text_public text_6">高效备考 一键搞定</div>
        </div>

        <div class="big_image_bg">
            <img class="big_image1" src="https://openpic.timelywise.cn/web/20250701/4-exam.png" alt="" loading="lazy">
        </div>

        <div class="app_width_box">
            <div class="text_public text_3">把英语转变为四大要素</div>
        </div>

        <div class="big_image_bg">
            <div class="elements_list">
                <img class="elements_list_item" v-for="(image, i) in elementsImages" :key="i" :src="image" alt="" loading="lazy">
            </div>
        </div>

        <div class="app_width_box">
            <div class="text_public text_4">知识点变互动卡片  好看  好记</div>
        </div>

        <div class="big_image_bg">
            <img class="big_image" src="https://openpic.timelywise.cn/web/20250701/6-knowledge-card.png" alt="" loading="lazy">
        </div>

        <div class="app_width_box1">
            <div class="text_public text_5">每种卡牌都有独特能力维度</div>
        </div>

        <div class="big_image_bg">
            <img class="big_image" src="https://openpic.timelywise.cn/web/20250701/7-card-detail.png" alt="" loading="lazy">
        </div>

        <div class="footer">
            <span>版权所有 &copy; {{ copyrightYearRange }} 上海乃时智能科技有限公司</span><br/>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">沪ICP备2024096932号-1</a>
            <span>邮箱：sales@timelywise.cn</span>&nbsp;&nbsp;&nbsp;
            <span>手机号：13267044568</span>
        </div>
        

    </div>
</template>

<script>

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { getPlatformInfo } from '@/utils/platformUtils.js';
import { getDownUrl } from '@/utils/api.js'


export default {
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            iosAppUrl: "https://itunes.apple.com/cn/app/id6738865813",
            macosAppUrl: "",
            windwosAppUrl: "",
            androidAppUrl: "",

            platformOsName: '',
            platformOsNameIcon: '',
            currentSlideIndex: 0,
            swiperInstance: null, // 添加这个变量来存储 swiper 实例
            slides: [
                { image: "https://openpic.timelywise.cn/web/20250701/question/1.png", title: '' },
                { image: "https://openpic.timelywise.cn/web/20250701/question/2.png", title: '' },
                { image: "https://openpic.timelywise.cn/web/20250701/question/3.png", title: '' },
                { image: "https://openpic.timelywise.cn/web/20250701/question/4.png", title: '' },
                { image: "https://openpic.timelywise.cn/web/20250701/question/5.png", title: '' },  
                { image: "https://openpic.timelywise.cn/web/20250701/question/6.png", title: '' },
                { image: "https://openpic.timelywise.cn/web/20250701/question/7.png", title: '' },
                { image: "https://openpic.timelywise.cn/web/20250701/question/8.png", title: '' },
                { image: "https://openpic.timelywise.cn/web/20250701/question/9.png", title: '' },
            ],
            elementsImages: [
                "http://openpic.timelywise.cn/web/20250701/word.png",
                "http://openpic.timelywise.cn/web/20250701/phrase.png",
                "http://openpic.timelywise.cn/web/20250701/sentence.png",
                "http://openpic.timelywise.cn/web/20250701/morpheme.png",
            ],
        }
    },
    
    computed: {
        swiper() {
            return this.swiperInstance;
        },
        copyrightYearRange() {
            const startYear = 2024;
            const currentYear = new Date().getFullYear();
            if (currentYear <= startYear) return `${startYear}`;
            return `${startYear} - ${currentYear}`;
        }
    },
    
    created() {
        this.getServerVersions();
        const { os } = getPlatformInfo();
        this.platformOsName = os;
        if(os == 'MacOS' || os == 'ios'){
            this.platformOsNameIcon = require('@/assets/download_macos.png');
        }else if(os == 'Windows'){
            this.platformOsNameIcon = require('@/assets/download_windows.png');
        }else if(os == 'Android'){
            // this.platformOsNameIcon = require('@/assets/download_macos.png'); 
        }
        
    },
    
    mounted() {
        
    },
    
    methods: {
        getServerVersions(){
            getDownUrl((res) => {
                if(res.code == 200){
                    let list = res.data.list;
                    for(let i = 0; i < list.length; i++){
                        if(list[i].platform.toLowerCase() == "macos"){
                            this.macosAppUrl = list[i].url;
                        }else if(list[i].platform.toLowerCase() == "windows"){
                            this.windwosAppUrl = list[i].url;
                        }else if(list[i].platform.toLowerCase() == "android"){
                            this.androidAppUrl = list[i].url;
                        }
                    }
                }
            });
        },
        // 添加 Swiper 实例初始化回调
        onSwiper(swiper) {
            this.swiperInstance = swiper;
        },
        
        // 添加 Swiper 滑动变化回调
        onSlideChange(swiper) {
            this.currentSlideIndex = swiper.realIndex;
            this.scrollToSlide(this.currentSlideIndex);
        },
        
        
        downApp() {
            let os = getPlatformInfo();
            console.log(os);
            let url;
            if(os.os.toLowerCase() == "macos"){
                url = this.macosAppUrl;
            }else if(os.os.toLowerCase() == "windows"){
                url = this.windwosAppUrl;
            }else if(os.os.toLowerCase() == "android"){
                url = this.androidAppUrl;
            }else if(os.os.toLowerCase() == "ios"){
                url = this.iosAppUrl;
            }
            
            const link = document.createElement('a');
            link.href = url;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        
        // 跳转到指定索引的 slide
        goToSlide(index) {
            if (this.swiper) {
                this.swiper.slideTo(index + 1);
                this.currentSlideIndex = index;
            }
        },
        
        nextSlide() {
            if (this.swiper) {
                this.swiper.slideNext();
            }
        },
        
        prevSlide() {
            if (this.swiper) {
                this.swiper.slidePrev();
            }
        },
        
        scrollToSlide(index) {
            const container = this.$refs.scrollContainer;
            const slide = this.$refs[`slide_${index}`]?.[0];
            
            if (container && slide) {
                const containerWidth = container.clientWidth;
                const slideLeft = slide.offsetLeft;
                const slideWidth = slide.clientWidth;
                const scrollTo = slideLeft - (containerWidth / 2) + (slideWidth / 2);

                container.scrollTo({
                    left: scrollTo,
                    behavior: "smooth",
                });
            }
        },
    },
}
</script>

<style scoped>
/* PC端=384px(2*192)，移动端=75px(2*37.5) */

.main {
    height: 100%;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 136px;
    padding-bottom: 20px;
}

.footer{
    margin-top: 200px;
}

.footer p{
    color: #ffffffb3;
    font-size: 16px;
}

.footer span{
    color: #ffffffb3;
    font-size: 16px;
}

.footer a{
    color: #7983f2;
    display: block;
}

.app_name {
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
}

.app_name img {
    width: 80px;
    height: 80px;
    aspect-ratio: 1/1;
    margin-right: 8px;
}

.app_name span {
    color: #FFF;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 64px;
    font-style: normal;
    font-weight: 600;
    line-height: 72px;
}

.app_width_box {
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
}


.app_desc {
    margin-top: 44px;
    margin-bottom: 80px;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 60px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -1.5px;

    background: linear-gradient(90deg, #CABFFF 0%, #FFF 50%, #BFEAFF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}


.download_box {

    background: none;
    border: none;
    padding: 16px 0;
    margin: 0;
    cursor: pointer;
    user-select: none;
    /* 防止文本选中干扰 */
    touch-action: manipulation;
    /* 优化触摸响应 */
    /* 默认鼠标样式（手型） */
    transition: all 0.3s ease;
    /* 平滑过渡效果 */
    border-radius: 12px;
    background: linear-gradient(90deg, rgba(170, 153, 255, 0.24) 0%, rgba(26, 179, 255, 0.24) 100%);

    color: #F7F8F8;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    /* 150% */
    letter-spacing: -0.5px;

    justify-content: center;
    align-items: center;

    display: flex;
    width: 294.63px;
    gap: 12px;
}

.download_box:hover {
    background: linear-gradient(90deg, rgba(170, 153, 255, 0.3) 0%, rgba(26, 179, 255, 0.3) 100%);
    border-radius: 12px;
    box-shadow: none;
}

.download_box:active{
    box-shadow: none;
    background-color: transparent;
}

.platform_icon {
    color: #F7F8F8;
    text-align: center;
    font-family: "SF Pro";
    width: 24px;
    font-style: normal;
    font-weight: 400;
}

.arrow_down img {
    width: 12px;
    flex-shrink: 0;
}

.download_list {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 18px;
    margin-bottom: 90px;
}

.download-link {
    color: #FFF;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 100% */
    letter-spacing: -0.32px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    margin: 0 20px;
}

.big_image_bg {
    display: flex;
    justify-content: center;
}

.big_image {
    width: 1200px;
    height: auto;
    object-fit: cover;  /* 关键：裁剪并填满容器 */
    display: block;     /* 去除图片底部间隙 */
}


.elements_list{
    width: 1200px;

    display: flex;
    justify-content: start;
    align-items: center;

    overflow-x: auto;  /* 横向滚动 */
    scrollbar-width: none;  /* Firefox 隐藏滚动条 */
    -webkit-overflow-scrolling: touch;  /* iOS 平滑滚动 */
    &::-webkit-scrollbar {
        display: none;  /* Chrome/Safari 隐藏滚动条 */
    }
}

.elements_list_item{
    width: 316px;
    aspect-ratio: 316 / 453;
    flex-shrink: 0;
    margin-right: 18.8px;
}


.carousel_container_box{
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
}


.carousel_container {
    top: 0;
    padding: 0;
    width: 1200px;
    aspect-ratio: 16 / 9;
}

.carousel_container_swiper{
    border-radius: 24px;
}


.carousel_item{
    aspect-ratio: 16 / 9;
    overflow: hidden;
}

 .carousel_item img{
    width: 100%;
    height: 100%;
    object-fit: cover;  /* 关键：裁剪并填满容器 */
    display: block;     /* 去除图片底部间隙 */
 }

.carousel_arrow_icon{
    width: 46px;
    height: 46x;
    margin: 0 24px;
    cursor: pointer;
}

.carousel_container_in{
    width: 1200px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius:4px;
    

    overflow-x: auto;  /* 横向滚动 */
    scrollbar-width: none;  /* Firefox 隐藏滚动条 */
    -webkit-overflow-scrolling: touch;  /* iOS 平滑滚动 */
    &::-webkit-scrollbar {
        display: none;  /* Chrome/Safari 隐藏滚动条 */
    }

    
}

.carousel_container_in_img{
    width: 136px;
    height: 88px;
    margin: 0 4px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
    
    aspect-ratio: 16 / 9;
    overflow: hidden;
}

.carousel_container_in_img_un{
    width: 136px;
    height: 88px;
    margin: 0 4px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
    opacity: 0.6;

    aspect-ratio: 16 / 9;
    overflow: hidden;
    
}

.carousel_container_in_img img, .carousel_container_in_img_un img{
    width: 100%;
    height: 100%;
    object-fit: cover;  /* 关键：裁剪并填满容器 */
    display: block;     /* 去除图片底部间隙 */
}


.text_public{
    text-align: center;
    font-family: "PingFang SC";
    font-size: 60px;
    font-style: normal;
    font-weight: 600;
    line-height: 66px; /* 110% */
    letter-spacing: -1.5px;
    margin-top: 144px;
    margin-bottom: 80px;
    
}

.text_1{
    background: linear-gradient(90deg, #FFABAB 0%, #FFF 40%, #BBADFF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text_2{
    background: linear-gradient(90deg, #8BC5FF 0%, #FFF 40%, #BFDFFF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text_3{
    background: linear-gradient(90deg, #FFABAB 0%, #FFF 40%, #BBADFF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text_4{
    background: linear-gradient(80deg, #FF8D76 0%, #FFF 40%, #FFCABF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text_5{
    background: linear-gradient(80deg, #FFAC71 0%, #FFF 40%, #FFDABF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.text_6{
    background: linear-gradient(90deg, #FFABAB 0%, #FFF 40%, #BBADFF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

@media screen and (max-width: 1390px) {

    .big_image{
        width: 80vw;
    }

    .carousel_container{
        width: 70vw;
    }

    .carousel_container_in{
        width: 70vw;
    }

    .big_image1_row{
        width: 80vw;
    }

    .big_image1_row img{
        width: 39vw;
    }

    .big_image1_row_div{
        width: 2vw;
    }

    .elements_list{
        width: 100vw;
        padding-left: 1vw;
    }
    

    .elements_list_item{
        width: 30vw;
        margin-right: 2vw;
    }

}

@media screen and (max-width: 768px) {

    .app_desc{
        font-size: 28px;
    }

    .download_list {
        display: block;
        margin-bottom: 10px;
    }

    .download-link {
        margin-bottom: 20px;
        display: block;
    }

    .big_image{
        width: 95vw;
    }

    .big_image1{
        width: 95vw;
    }

    .carousel_container{
        width: 80vw;
    }

    .carousel_container_swiper{
        border-radius: 16px;
    }

    .carousel_arrow_icon{
        width: 36px;
        height: 36px;
        margin: 0 2px;
    }

    .carousel_container_in{
        width: 80vw;
    }

    .elements_list{
        width: 100vw;
        padding-left: 2vw;
        justify-content: start;
    }

    .elements_list_item{
        width: 30vw;
        margin-right: 2vw;
    }

    .text_public{
        margin-top: 40px;
        margin-bottom: 20px;
        font-size: 28px;
    }

}

</style>
